import axios from 'axios';
import { getAuthHeaders } from '../utils/auth';
import { API_URL } from '../constants/urls';

export interface OrganizationMember {
  id: string;
  user_id: string;
  organization_id: string;
  role: string;
  email: string;
  first_name?: string;
  last_name?: string;
  created_at: string;
  updated_at: string;
}

export const organizationService = {
  async getOrganizationMembers(
    organizationId: string,
  ): Promise<OrganizationMember[]> {
    try {
      const response = await axios.get(
        `${API_URL}/organizations/${organizationId}/members`,
        { headers: getAuthHeaders() },
      );
      return response.data;
    } catch (error) {
      console.error('Failed to fetch organization members:', error);
      return [];
    }
  },

  async inviteMember(organizationId: string, email: string, role: string) {
    const response = await axios.post(
      `${API_URL}/organizations/${organizationId}/invitations`,
      { email, role },
      { headers: getAuthHeaders() },
    );
    return response.data;
  },

  async updateMemberRole(organizationId: string, userId: string, role: string) {
    const response = await axios.put(
      `${API_URL}/organizations/${organizationId}/members/${userId}`,
      { role },
      { headers: getAuthHeaders() },
    );
    return response.data;
  },

  async removeMember(organizationId: string, userId: string) {
    const response = await axios.delete(
      `${API_URL}/organizations/${organizationId}/members/${userId}`,
      { headers: getAuthHeaders() },
    );
    return response.data;
  },
};
